<template>
  <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
    <div>
      <h2 class="text-2xl font-semibold">Complete action</h2>
      <span>Enter confirmation code to save new card.</span>

      <div class="mt-4">
        <p>Enter verification code sent to random.email@company.com</p>
        <div class="flex justify-center py-4">
          <input
            class="input"
            placeholder="--"
            v-model="card.first"
            @keyup="changeInputField"
            @paste="pasteCode($event)"
          />
          <input
            class="input"
            placeholder="--"
            v-model="card.second"
            @keyup="changeInputField"
            @paste="pasteCode($event)"
          />
          <input
            class="input"
            placeholder="--"
            v-model="card.third"
            @keyup="changeInputField"
            @paste="pasteCode($event)"
          />
          <input
          class="input"
          placeholder="--"
          v-model="card.forth"
          @keyup="changeInputField"
          @paste="pasteCode($event)"
        />
        <input
          class="input"
          placeholder="--"
          v-model="card.fifth"
          @keyup="changeInputField"
          @paste="pasteCode($event)"
        />
        <input
          class="input"
          placeholder="--"
          v-model="card.sixth"
          @keyup="changeInputField"
          @paste="pasteCode($event)"
        />
        </div>
      </div>
      

      <div class="flex items-center justify-between w-full">
        <button>Go Back</button>
        <button class="py-2 px-4 bg-primary-yellow">Finish</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    pasteCode(e) {
      e.preventDefault();
      let code = e.clipboardData.getData("text/plain");
      console.log("Code:", code);
      if (code.length == 6) {
        this.card = {
          first: code.charAt(0),
          second: code.charAt(1),
          third: code.charAt(2),
          fourth: code.charAt(3),
          fifth: code.charAt(4),
          sixth: code.charAt(5),
        };
      } else {
        this.generateToast("Invalid code entered!", "error");
        this.authenticationCode.first = "";
      }
    }
  },
  data() {
    return {
      card: {
        first: "",
        second: "",
        third: "",
        forth: "",
        fifth: "",
        sixth: "",
      },
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.input {
  @apply w-12 h-12 text-primary-black border-2 border-gray-300 flex text-center items-center rounded-md mx-2;
}
</style>
